import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Dr. Martín Sánchez',
  role: 'Abogado - Derecho Civil y Comercial',
  city: 'Buenos Aires',
  text: 'Antes perdía horas buscando modelos viejos para adaptar. Ahora tengo una estructura clara que me permite enfocarme en la estrategia del caso y no en cómo redactar la pregunta. Excelente recurso.'
}, {
  name: 'Dra. Florencia Ruiz',
  role: 'Abogada Laboralista',
  city: 'Córdoba',
  text: 'La claridad que logré en mis últimos escritos es notable. Los peritos responden exactamente lo que necesito porque aprendí a no dejar margen de ambigüedad. Vale cada peso.'
}, {
  name: 'Dr. Diego Morales',
  role: 'Abogado Penalista',
  city: 'Rosario',
  text: 'Siempre sentí que mis puntos periciales podían ser mejores, pero no sabía cómo sistematizarlos. Este material me dio exactamente eso: un sistema. Lo recomiendo a cualquier colega litigante.'
}, {
  name: 'Dra. Valentina López',
  role: 'Abogada - Daños y Perjuicios',
  city: 'Mendoza',
  text: 'Dejé de pelearme con la hoja en blanco. Las estructuras adaptables son una salvación cuando tenés plazos cortos y necesitás presentar algo sólido y profesional.'
}, {
  name: 'Dr. Juan Pablo Rodríguez',
  role: 'Abogado de Familia',
  city: 'La Plata',
  text: 'Es de esos recursos que se pagan solos con el tiempo que te ahorran en el primer caso que lo usás. Muy práctico, directo al punto y sin teoría innecesaria.'
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-143">
      <div className="max-w-5xl mx-auto" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-146">
            Lo que dicen otros colegas
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-147"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-148">
          {testimonials.map((t, i) => <div key={i} className={`bg-slate-800/80 p-8 rounded-2xl border border-slate-700 relative shadow-xl ${i === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-149">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-slate-700 opacity-50" data-id="element-150" />
              <div className="flex gap-1 mb-6" data-id="element-151">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-152" />)}
              </div>
              <p className="text-slate-300 mb-8 italic text-base leading-relaxed" data-id="element-153">
                "{t.text}"
              </p>
              <div data-id="element-154">
                <p className="font-bold text-white text-lg" data-id="element-155">{t.name}</p>
                <p className="text-sm text-gold-400 mt-1" data-id="element-156">{t.role}</p>
                <p className="text-sm text-slate-500 mt-1" data-id="element-157">{t.city}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-16" data-id="element-158">
          <a href="https://checkout.ebookpoint.shop/cart/59452963192913:1" className="inline-block w-full md:w-auto bg-[#dc2626] hover:bg-[#ef4444] text-white font-black text-xl px-12 py-5 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:-translate-y-1 uppercase tracking-wide border-b-4 border-[#991b1b]" data-id="element-159">
            QUIERO ESTOS RESULTADOS
          </a>
        </div>
      </div>
    </section>;
}